import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Post } from '../container';

@Component({
  selector: 'app-contentversions',
  imports: [DatePipe],
  templateUrl: './contentversions.component.html',
  styleUrl: './contentversions.component.scss'
})
export class ContentversionsComponent {
  @Input() organizationKey: string = '';
  @Input() projectKey: string = '';
  @Input() userId: string = '';
  @Input() isReadOnly: boolean = false;
  @Input() contentVersions: Post[] = [];
  @Output() onVersionSelected = new EventEmitter<Post>();

  selectVersion(version: Post) {
    this.onVersionSelected.emit(version);
  }
}
